import { combineReducers } from 'redux'
import signatureRequest from './signatureRequest'

export default combineReducers({
  signatureRequest,
})
